import { render, staticRenderFns } from "./safety-inventory-add.vue?vue&type=template&id=26e43337&scoped=true&"
import script from "./safety-inventory-add.vue?vue&type=script&lang=ts&"
export * from "./safety-inventory-add.vue?vue&type=script&lang=ts&"
import style0 from "./safety-inventory-add.vue?vue&type=style&index=0&id=26e43337&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e43337",
  null
  
)

export default component.exports